class CartCountBubble extends HTMLElement {
    constructor() {
        super();
        this.currentCartCount = this.dataset.count ? parseInt(this.dataset.count, 10) : 0;
        this.toggleVisibility();
        this.onPageShow = this.onPageShow.bind(this);
        this.onCartUpdate = this.onCartUpdate.bind(this);
    }
    connectedCallback() {
        this.ensureCartBubbleIsCorrect();
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
        window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
        window.removeEventListener('pageshow', this.onPageShow);
    }

    /**
     * Handles the page show event when the page is restored from cache.
     * @param {PageTransitionEvent} event - The page show event.
     */
    onPageShow(event) {
        if (event.persisted) {
            this.ensureCartBubbleIsCorrect();
        }
    };

    toggleVisibility() {
        if (this.currentCartCount > 0) {
            this.classList.remove("visually-hidden");
        } else {
            this.classList.add("visually-hidden");
        }
    }
    persistCount() {
        sessionStorage.setItem(
            'cart-count',
            JSON.stringify({
                value: String(this.currentCartCount),
                timestamp: Date.now(),
            })
        );
    }

    /**
     * Handles the cart update event.
     * @param {CartUpdateEvent} event - The cart update event.
     */
    async onCartUpdate(event) {
        this.currentCartCount = await this.fetchCartCount();
        this.toggleVisibility();
        this.persistCount();
        this.renderCartBubble();
    };

    async fetchCartCount() {
        const response = await fetch('/?sections=cart-count');
        const data = await response.json();
        const sectionHTML = data['cart-count'];

        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHTML, 'text/html');

        const scriptTag = doc.querySelector('#cart-count');
        if (scriptTag) {
            const { cart_count } = JSON.parse(scriptTag.textContent);
            return cart_count;
        }
        return 0;
    }

    renderCartBubble() {
        if (this.currentCartCount > 0) {
            this.querySelectorAll('span').forEach(span => {
                span.textContent = this.currentCartCount + (span.classList.contains('visually-hidden') ? ' items' : '');
            });
        }
    };

    /**
     * Checks if the cart count is correct.
     */
    ensureCartBubbleIsCorrect() {
        const sessionStorageCount = sessionStorage.getItem('cart-count');
        if (sessionStorageCount === null) return;

        try {
            const { value, timestamp } = JSON.parse(sessionStorageCount);
            if (value == this.currentCartCount) return;
            if (Date.now() - timestamp < 10000) {
                this.currentCartCount = value;
                this.renderCartBubble();
                this.toggleVisibility();
            }
        } catch (_) {
            // no-op
        }
    };
}


if (!customElements.get('cart-count-bubble')) {
    customElements.define('cart-count-bubble', CartCountBubble);
}
